import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { checkEmpty } from '@/utils/commonFunctions';
import AboutMe from '../AboutMe';
import AcademicTimeline from '../AcademicTimeline';
import ContactMe from '@/containers/ContactMe';
import Contribution from '../Contribution';
import Drawer from '../Drawer';
import ExperienceTimeline from '../ExperienceTimeline';
import Footer from '../Footer';
import Projects from '../Projects';
import Skills from '../Skills';
import { StyledContainer, StyledProgressBar } from './styles';

export default function Layout({
  repos,
  skills,
  getReposRequest,
  getSkillsRequest,
  startLoaderRequest,
  getAcademicRequest,
  getExperienceRequest,
  experienceData,
  academicDetails,
}) {
  useEffect(() => {
    startLoaderRequest();
    getReposRequest();
    getSkillsRequest();
    getExperienceRequest();
    getAcademicRequest();
  }, [getReposRequest, getSkillsRequest, startLoaderRequest, getExperienceRequest, getAcademicRequest]);

  return (
    <StyledContainer id="home">
      <StyledProgressBar id="scroll" />
      <Box sx={{ display: 'flex' }}>
        <Drawer />
        <Box component="main" className="text-gray-400 bg-gray-900 body-font" sx={{ flexGrow: 1, width: { lg: 'calc(100% - 260px)', xs: '100%' } }}>
          <Grid xs={12} lg={12} md={12} sx={{ py: 3 }} item>
            <AboutMe />
            <Contribution />
            {!checkEmpty(repos) ? <Projects repos={repos} /> : null}
            {!checkEmpty(experienceData) ? <ExperienceTimeline experienceData={experienceData} /> : null}
            {!checkEmpty(skills) ? <Skills skills={skills} /> : null}
            {!checkEmpty(academicDetails) ? <AcademicTimeline academicDetails={academicDetails} /> : null}
            <ContactMe />
          </Grid>
          <Footer />
        </Box>
      </Box>
    </StyledContainer>
  );
}

Layout.propTypes = {
  repos: PropTypes.oneOfType([PropTypes.array]).isRequired,
  skills: PropTypes.oneOfType([PropTypes.array]).isRequired,
  getReposRequest: PropTypes.func.isRequired,
  getSkillsRequest: PropTypes.func.isRequired,
  startLoaderRequest: PropTypes.func.isRequired,
  getAcademicRequest: PropTypes.func.isRequired,
  getExperienceRequest: PropTypes.func.isRequired,
  experienceData: PropTypes.oneOfType([PropTypes.array]).isRequired,
  academicDetails: PropTypes.oneOfType([PropTypes.array]).isRequired,
};
